var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurposeLoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 26C13.6295 25.9995 13.2676 25.8782 12.9616 25.6519C8.4278 22.3175 6.46463 20.0312 5.38181 18.6019C3.07424 15.555 1.96949 12.4269 2.00064 9.03938C2.03698 5.1575 4.91164 2 8.40876 2C10.9517 2 12.713 3.55188 13.7387 4.84438C13.7712 4.88491 13.8113 4.91741 13.8564 4.93968C13.9015 4.96195 13.9504 4.97348 14 4.97348C14.0496 4.97348 14.0985 4.96195 14.1436 4.93968C14.1887 4.91741 14.2288 4.88491 14.2613 4.84438C15.287 3.55063 17.0483 2 19.5912 2C23.0884 2 25.963 5.1575 25.9994 9.04C26.0305 12.4281 24.9246 15.5563 22.6182 18.6025C21.5354 20.0319 19.5722 22.3181 15.0384 25.6525C14.7323 25.8786 14.3705 25.9997 14 26Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurposeLoveIcon);
export default __webpack_public_path__ + "static/media/purpose-love-icon.eef3881491be88a07a655b09556e7079.svg";
export { ForwardRef as ReactComponent };